<template>
  <div>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
          <el-form-item label="轮播图名称：" prop="name">
            <el-input style="width: 424px;" v-model="ruleForm.name" placeholder="请输入轮播图名称"></el-input>
          </el-form-item>
          <el-form-item label="图片：" prop="imgUrl">
            <el-upload
              :action="baseUrl+'/system/common/upload/uploadFile'"
              list-type="picture-card"
              :headers="{'Authorization': token}"
              :multiple="false"
              :limit="1"
              :file-list="fileList"
              :on-remove="delImgBtn"
              :on-success="bannerImgBtn">
              <i class="el-icon-plus"></i>
              <div slot="tip" class="el-upload__tip">若需要更换图片，请先删除原图片</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="跳转类型：" prop="type">
            <el-select style="width: 424px;" v-model="ruleForm.type" placeholder="请选择跳转类型">
              <el-option label="不跳转" :value="0"></el-option>
              <el-option label="内部跳转" :value="1"></el-option>
              <el-option label="跳转外部链接" :value="2"></el-option>
              <el-option label="跳转小程序" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="ruleForm.type == 1" label="内部链接：" prop="url">
            <el-input style="width: 424px;" v-model="ruleForm.url" placeholder="请输入跳转链接"></el-input>
            <div class="mt-warm-txt"><span>商品路径：/pages/cate/cate?dataId=</span><span>ID在商品列表获取</span></div>
          </el-form-item>
          <el-form-item v-if="ruleForm.type == 2" label="外部链接：" prop="url">
            <el-input style="width: 424px;" v-model="ruleForm.url" placeholder="请输入跳转链接"></el-input>
          </el-form-item>
          <el-form-item v-if="ruleForm.type == 3" label="跳转小程序：" prop="minAppId">
            <el-input style="width: 424px;" v-model="ruleForm.minAppId" placeholder="请输入小程序appid"></el-input>
          </el-form-item>
          <el-form-item v-if="ruleForm.type == 3" label="小程序路径：" prop="url">
            <el-input style="width: 424px;" v-model="ruleForm.url" placeholder="请输入小程序路径"></el-input>
          </el-form-item>
          <el-form-item label="是否开启：" prop="status">
            <el-switch
              v-model="ruleForm.status"
              active-color="#1890FF"
              inactive-color="#CCCCCC">
            </el-switch>
          </el-form-item>
          <el-form-item label="排序：" prop="sort">
            <el-input style="width: 424px;" v-model="ruleForm.sort" placeholder="请输入排序（默认 1 ）"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="saveBtn">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { bannerAdd, bannerInfo, bannerEdit } from '@/api/banner'
export default {
  name: 'Banner_add',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:this.$token,
      dataId: this.$route.query.dataId,
      fileList: [],
      ruleForm: {
        name: '',
        imgUrl: '',
        type: '',
        url: '',
        minAppId: '',
        sort: '',
        status: false
      },
      rules: {
        name: [
          { required: true, message: '请输入轮播图名称', trigger: 'blur' }
        ],
        imgUrl: [
          { required: true, message: '请上传图片', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择跳转类型', trigger: 'blur' }
        ],
        url: [
          { required: true, message: '请选择跳转类型', trigger: 'blur' }
        ],
        minAppId: [
          { required: true, message: '请输入小程序appid', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    let token = sessionStorage.getItem('token')
    if (!token) {
      token = ''
    }
    this.token = token;
    if (this.$route.query.dataId === undefined || this.$route.query.dataId === 'undefined') {
      this.dataId = ''
    } else {
      let that = this
      bannerInfo({ id: that.dataId }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.ruleForm.name = data.name
          let status = false
          if (data.status === 1) {
            status = true
          }
          that.ruleForm.status = status
          that.ruleForm.sort = data.sort
          that.ruleForm.imgUrl = data.imgUrl
          that.fileList.push({url: data.imgUrl})
          that.ruleForm.type = data.type
          that.ruleForm.url = data.url
          that.ruleForm.minAppId = data.minAppId
        }
      })
    }
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    bannerImgBtn (file) {
      this.ruleForm.imgUrl = file.data.fileUrl
    },
    /* 删除上传的图片 */
    delImgBtn(file,fileList){
      var imgUrl = '';
      fileList.forEach(function(item){
        imgUrl = item.url;
      });
      this.ruleForm.imgUrl = imgUrl;
    },
    // 保存操作
    saveBtn () {
      let that = this
      let dataId = that.dataId
      let name = that.ruleForm.name
      let type = that.ruleForm.type
      let imgUrl = that.ruleForm.imgUrl
      let url = that.ruleForm.url
      var minAppId = that.ruleForm.minAppId
      let status = that.ruleForm.status ? 1 : 0
      let sort = that.ruleForm.sort === '' ? 1 : that.ruleForm.sort
      if (name === '') {
        this.$message.error('请输入轮播图名称')
        return false
      }
      if (imgUrl === '') {
        this.$message.error('请上传图片')
        return false
      }
      if (type === '') {
        this.$message.error('请选择跳转类型')
        return false
      }
      if (type == 1 && url === '') {
        this.$message.error('请输入内部链接')
        return false
      }
      if (type == 2 && url === '') {
        this.$message.error('请输入外部链接')
        return false
      }
      if (type == 3 && minAppId === '') {
        this.$message.error('请输入小程序appid')
        return false
      }
      if (type == 3 && url === '') {
        this.$message.error('请输入小程序路径')
        return false
      }
      let passData = {
        name: name, imgUrl: imgUrl, status: status, type: type, minAppId: minAppId, url: url, sort: sort
      }
      if (dataId !== '') {
        passData = {
          id: dataId, name: name, type: type, imgUrl: imgUrl, url: url, minAppId: minAppId, status: status, sort: sort
        }
        bannerEdit(passData).then((res) => {
          that.backDataFun(res)
        })
      }else{
        bannerAdd(passData).then((res) => {
         that.backDataFun(res)
        })
      }
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(-1)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/banner/Add.vue